import React from "react";
// import styled from "styled-components";
// import "../App.css";
const Stats = () => {
  return (
    
    <section  className="bg-gradient-to-b from-indigo-900 via-black-200 to-black  text-slate-200 py-10 ">
    <div className="container mx-auto px-4 sm:px-10">
      <div className="text-center md:max-w-4xl sm:max-w-2xl mx-auto mb-12">
        <h2 className="text-2xl md:text-4xl font-bold mb-20">Github Statistics</h2>
        <div style={{margin:"auto"}}>
     
 
      <div
      className="md:flex md:justify-center"
        style={{
          width: "100%",
          height: "300px",
          margin: "auto",
          gap:"20px"
            
        }}
      >
         <a href="https://github.com/martina024">
          <img
          // className="mb-20"
            align="center"
            src="https://github-readme-streak-stats.herokuapp.com?user=martina024"
            style={{marginBottom:"20px"}}
          />
        </a>

     
        <a href="https://github.com/martina024">
          <img
            align="center"
           
            src="https://github-readme-stats.vercel.app/api?username=martina024&count_private=true&show_icons=true" //stats
          />
        </a>
      </div>
    </div>
     
      </div>
    </div>
  </section>




    
   
  );
};

export default Stats;